export const Role = {
  ADMINISTRATOR: "administrator",
  INVESTOR: "investor",
};
